import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import searchFetcher from "@/common/fetchSearchServices";
import { SEARCH_LAB_ENABLED } from "@globalConfig";
import { searchLab__recommendations } from "@/apis/searchLab/searchLab";
export var api__getRecommendedPosts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userId) {
    var _res$data;
    var limit,
      params,
      res,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          limit = _args.length > 1 && _args[1] !== undefined ? _args[1] : 20;
          if (!SEARCH_LAB_ENABLED) {
            _context.n = 3;
            break;
          }
          _context.n = 1;
          return searchLab__recommendations(null, {
            user_id: userId,
            limit: limit
          });
        case 1:
          _t = _context.v;
          if (_t) {
            _context.n = 2;
            break;
          }
          _t = null;
        case 2:
          return _context.a(2, _t);
        case 3:
          params = {
            user_id: userId,
            limit: limit
          };
          _context.n = 4;
          return searchFetcher().get("/search/recommended", {
            params: params
          });
        case 4:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api__getRecommendedPosts(_x) {
    return _ref.apply(this, arguments);
  };
}();